import angular from "angular"

// Define AngularJS component wrapper
class StudentProfileComponent {
  static get $inject() {
    return ["$state", "$stateParams"]
  }
  constructor($state, $stateParams) {
    this.$state = $state
    this.$stateParams = $stateParams

    this.studentId = $stateParams.studentId
  }

  handleGo(state) {
    this.$state.go(state)
  }
}

angular.module("appModule").component("satdStudentProfile", {
  template: require("html-loader!./student-profile.component.html"),
  controller: StudentProfileComponent
})

import "./components/info/info.component"
import "./components/home/home.component"
import "./components/extra_info/extra-info.component"
import "./components/attentions/attentions.component"
import "./components/attention/attention.component"
import "./components/alerts/alerts.component"
import "./components/alert/alert.component"
import "./components/grades/grades.component"
import "./components/comments/comments.component"
import "./components/add_attention/add-attention.component"
import "./components/new_attention/new-attention.component"
import "./components/new_past_attention/new-past-attention.component"
import "./components/finish_attention/finish-attention.component"
import "./components/attention_finished/attention-finished.component"
import "./components/attention_created/attention-created.component"
import "./components/raise_alert/raise-alert.component"
import "./components/alert_raised/alert-raised.component"
import "./components/change_situation/change-situation.component"
import "./components/attentions_by_type/attentions-by-type.component"

export default StudentProfileComponent
